import styled from "styled-components";

const StyledInput = styled.input`
  font-size: 1rem;
  padding: 2px;
  margin: 0px 10px;
  border-color: #3273dc;
  height: 2.5em;
  padding-left: calc(0.75em - 1px);
  padding-right: calc(0.75em - 1px);
  border: 0.5px solid #3273dc;
  border-radius: 4px;
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
`;

export default StyledInput;
